import { Button, Progress, Space } from "antd"
import VSpace from "../common/VSpace"
import { blue, green, grey } from "@ant-design/colors"
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons"
import { useContext } from "react"
import ChecklistContext from "./ChecklistContext"
import { getSectionTotals } from "./checklistModel"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type Props = {
  isShowing: boolean
  onIsShowingChange: (x: boolean) => void
}

const ChecklistHeader = ({isShowing, onIsShowingChange}: Props) => {
  const { data } = useContext(ChecklistContext)
  const totals = getSectionTotals(data)
  const percent = totals.total < 1 ? 0 : totals.completed / totals.total

  return <VSpace>
      <div style={{textAlign: 'center', position: 'relative'}}>
        <div style={{fontSize: '24px', fontWeight: 'bold'}}>SynkedUP Success Checklist</div>
        <span>{totals.completed} out of {totals.total} sections marked complete</span>
        <div style={{position: 'absolute', bottom: 0, right: 0}}>
          <Button type="text" onClick={() => onIsShowingChange(!isShowing)} style={{color: isShowing ? grey[2] : blue.primary}}>
            {isShowing && <Space>Hide checklist <FontAwesomeIcon icon={faChevronUp} /></Space>}
            {!isShowing && <Space>Show checklist <FontAwesomeIcon icon={faChevronDown} /></Space>}
          </Button>
        </div>
      </div>
      <Progress percent={percent * 100} strokeColor={green.primary} showInfo={false}/>
  </VSpace>
}

export default ChecklistHeader